import { duration } from '../utils/duration';
import { tuple } from '../utils/types';

export const LOCAL_CURRENCY = process.env.REVENUE_CURRENCY ?? ('JPY' as const);

export const gemsProductIds = tuple(
  'buruburu_gems_100',
  'buruburu_gems_1000',
  'buruburu_gems_12000',
  'buruburu_gems_18000',
  'buruburu_gems_3200',
  'buruburu_gems_350',
  'buruburu_gems_6000',

  // Shop Bundles Gems
  'buruburu_gems_200',
  'buruburu_gems_1000_1200',
  'buruburu_gems_2000',
  'buruburu_gems_5500',
  'buruburu_gems_10000',
  'buruburu_gems_20000',

  // Shop Bundles Packs
  'buruburu_pet_starter_pack',
  'buruburu_pet_starter_pack_2',
  'buruburu_pet_starter_pack_3',
  'buruburu_starter_pack',
  'buruburu_mini_pack',
  'buruburu_small_pack',
  'buruburu_medium_pack',
  'buruburu_large_pack',
  'buruburu_grande_pack',
  'buruburu_jumbo_pack',

  // Bundle Sale Products
  'buruburu_booster_sale',
  'buruburu_sale_rm_04p_2',
  'buruburu_sale_rm_10p',
  'buruburu_sale_rm_16p',
  'buruburu_sale_rm_22p',
  'buruburu_sale_rm_28p',
  'buruburu_sale_rm_34p',
  'buruburu_sale_rm_40p',
  'buruburu_sale_rm_46p',
  'buruburu_sale_cm_04p',
  'buruburu_sale_cm_10p',
  'buruburu_sale_cm_16p',
  'buruburu_sale_cm_22p',
  'buruburu_sale_cm_28p',
  'buruburu_sale_cm_34p',
  'buruburu_sale_cm_40p',
  'buruburu_sale_cm_46p',
  'buruburu_sale_cm_52p',
  'buruburu_sale_cm_58p',

  // Battle Pass
  'buruburu_buru_pass',

  // Flash sale
  'buruburu_flashsale_continue',

  // Conversion sale
  'buruburu_conversionsale_foryou',

  // Piggy Bank
  'buruburu_piggy_bank_200',
  'buruburu_piggy_bank_500',
);

export type GemsProductId = (typeof gemsProductIds)[number];

export type ProductId = GemsProductId;

export const productIds: ProductId[] = [...gemsProductIds];

export type ProductRewardType = 'paidGems' | 'freeGems';
export type ProductReward = Partial<Record<ProductRewardType, number>> & {
  hot?: boolean;
};

export type PurchaseFlow = 'apple' | 'google' | 'openWeb' | 'liff';

export const gemsRewardTable: Record<GemsProductId, ProductReward> = {
  buruburu_gems_100: {
    paidGems: 100,
  },
  buruburu_gems_350: {
    paidGems: 308,
    freeGems: 42,
  },
  buruburu_gems_1000: {
    paidGems: 816,
    freeGems: 184,
    hot: true,
  },
  buruburu_gems_3200: {
    paidGems: 2450,
    freeGems: 750,
  },
  buruburu_gems_6000: {
    paidGems: 4083,
    freeGems: 1917,
  },
  buruburu_gems_12000: {
    paidGems: 7500,
    freeGems: 4500,
  },
  buruburu_gems_18000: {
    paidGems: 10000,
    freeGems: 8000,
  },

  // Shop Bundles Gems
  buruburu_gems_200: {
    paidGems: 200,
  },
  buruburu_gems_1000_1200: {
    paidGems: 600,
    freeGems: 200,
  },
  buruburu_gems_2000: {
    paidGems: 1333,
    freeGems: 667,
  },
  buruburu_gems_5500: {
    paidGems: 3333,
    freeGems: 2167,
  },
  buruburu_gems_10000: {
    paidGems: 5333,
    freeGems: 4667,
  },
  buruburu_gems_20000: {
    paidGems: 9333,
    freeGems: 10667,
  },

  // Shop Bundles Packs
  buruburu_pet_starter_pack: {
    paidGems: 2000,
  },
  buruburu_pet_starter_pack_2: {
    paidGems: 600,
  },
  buruburu_pet_starter_pack_3: {
    paidGems: 0,
  },
  buruburu_starter_pack: {
    paidGems: 200,
  },
  buruburu_mini_pack: {
    paidGems: 600,
  },
  buruburu_small_pack: {
    paidGems: 1000,
  },
  buruburu_medium_pack: {
    paidGems: 2000,
  },
  buruburu_large_pack: {
    paidGems: 5000,
  },
  buruburu_grande_pack: {
    paidGems: 10000,
  },
  buruburu_jumbo_pack: {
    paidGems: 13000,
  },

  // Bundle Sale Products
  buruburu_booster_sale: {
    paidGems: 1500,
  },
  buruburu_sale_rm_04p_2: {
    paidGems: 1500,
  },
  buruburu_sale_rm_10p: {
    paidGems: 2000,
  },
  buruburu_sale_rm_16p: {
    paidGems: 2500,
  },
  buruburu_sale_rm_22p: {
    paidGems: 3000,
  },
  buruburu_sale_rm_28p: {
    paidGems: 2500,
  },
  buruburu_sale_rm_34p: {
    paidGems: 5000,
  },
  buruburu_sale_rm_40p: {
    paidGems: 8000,
  },
  buruburu_sale_rm_46p: {
    paidGems: 18000,
  },
  buruburu_sale_cm_04p: {
    paidGems: 1000,
  },
  buruburu_sale_cm_10p: {
    paidGems: 1500,
  },
  buruburu_sale_cm_16p: {
    paidGems: 2000,
  },
  buruburu_sale_cm_22p: {
    paidGems: 3000,
  },
  buruburu_sale_cm_28p: {
    paidGems: 2400,
  },
  buruburu_sale_cm_34p: {
    paidGems: 4000,
  },
  buruburu_sale_cm_40p: {
    paidGems: 5000,
  },
  buruburu_sale_cm_46p: {
    paidGems: 6500,
  },
  buruburu_sale_cm_52p: {
    paidGems: 8000,
  },
  buruburu_sale_cm_58p: {
    paidGems: 18000,
  },

  // Battle Pass
  buruburu_buru_pass: {},

  // Flash sale
  buruburu_flashsale_continue: {
    paidGems: 500,
  },

  // Conversion sale
  buruburu_conversionsale_foryou: {
    paidGems: 200,
  },

  // Piggy Bank
  // Piggy Bank is deactivated after A/B 0454 resolved to control. Keep
  // static zero rewards so product metadata remains complete for existing
  // pending-payment records.
  buruburu_piggy_bank_200: {
    paidGems: 0,
  },
  buruburu_piggy_bank_500: {
    paidGems: 0,
  },
};

// Obtained from App Store Connect
//@see https://appstoreconnect.apple.com/apps/1638675792/appstore/iaps/1639252100/pricing-matrix
export const prices: Record<ProductId, number> =
  // USD
  {
    buruburu_gems_100: 99,
    buruburu_gems_350: 299,
    buruburu_gems_1000: 799,
    buruburu_gems_3200: 2399,
    buruburu_gems_6000: 3999,
    buruburu_gems_12000: 7499,
    buruburu_gems_18000: 9999,

    // Shop Bundles Gems - USD
    buruburu_gems_200: 199,
    buruburu_gems_1000_1200: 799,
    buruburu_gems_2000: 1299,
    buruburu_gems_5500: 3499,
    buruburu_gems_10000: 4999,
    buruburu_gems_20000: 9999,

    // Shop Bundles Pack - USD
    buruburu_pet_starter_pack: 0.068, // Special case 10 JPY, exist only on Open Web, Do not exist for Native apps
    buruburu_pet_starter_pack_2: 0.068, // Special case 10 JPY, exist only on Open Web, Do not exist for Native apps
    buruburu_pet_starter_pack_3: 0.068, // Special case 10 JPY, exist only on Open Web, Do not exist for Native apps
    buruburu_starter_pack: 99,
    buruburu_mini_pack: 699,
    buruburu_small_pack: 999,
    buruburu_medium_pack: 1999,
    buruburu_large_pack: 3999,
    buruburu_grande_pack: 7999,
    buruburu_jumbo_pack: 9999,

    // Bundle Sale Products - USD
    buruburu_booster_sale: 699,
    buruburu_sale_rm_04p_2: 299,
    buruburu_sale_rm_10p: 499,
    buruburu_sale_rm_16p: 799,
    buruburu_sale_rm_22p: 1499,
    buruburu_sale_rm_28p: 1999,
    buruburu_sale_rm_34p: 2999,
    buruburu_sale_rm_40p: 4999,
    buruburu_sale_rm_46p: 9999,
    buruburu_sale_cm_04p: 399,
    buruburu_sale_cm_10p: 699,
    buruburu_sale_cm_16p: 999,
    buruburu_sale_cm_22p: 1499,
    buruburu_sale_cm_28p: 2299,
    buruburu_sale_cm_34p: 2499,
    buruburu_sale_cm_40p: 2999,
    buruburu_sale_cm_46p: 3999,
    buruburu_sale_cm_52p: 4999,
    buruburu_sale_cm_58p: 9999,

    // Battle Pass - USD
    buruburu_buru_pass: 999,

    // Flash sale - USD
    buruburu_flashsale_continue: 199,

    // Conversion sale - USD
    buruburu_conversionsale_foryou: 99,

    // Piggy Bank - USD
    buruburu_piggy_bank_200: 149,
    buruburu_piggy_bank_500: 349,
  };

export const webIAPPrices: Record<ProductId, number> =
  // JPY
  {
    buruburu_gems_100: 100,
    buruburu_gems_350: 400,
    buruburu_gems_1000: 1200,
    buruburu_gems_3200: 3500,
    buruburu_gems_6000: 6000,
    buruburu_gems_12000: 11000,
    buruburu_gems_18000: 15000,

    // Shop Bundles Gems - JPY
    buruburu_gems_200: 300,
    buruburu_gems_1000_1200: 1200,
    buruburu_gems_2000: 2000,
    buruburu_gems_5500: 5000,
    buruburu_gems_10000: 8000,
    buruburu_gems_20000: 14000,

    // Shop Bundles - JPY
    buruburu_pet_starter_pack: 10,
    buruburu_pet_starter_pack_2: 10,
    buruburu_pet_starter_pack_3: 10,
    buruburu_starter_pack: 150,
    buruburu_mini_pack: 1000,
    buruburu_small_pack: 1500,
    buruburu_medium_pack: 3000,
    buruburu_large_pack: 6000,
    buruburu_grande_pack: 12000,
    buruburu_jumbo_pack: 14500,

    // Bundle Sale Products - JPY
    buruburu_booster_sale: 1000,
    buruburu_sale_rm_04p_2: 400,
    buruburu_sale_rm_10p: 700,
    buruburu_sale_rm_16p: 1200,
    buruburu_sale_rm_22p: 2200,
    buruburu_sale_rm_28p: 3000,
    buruburu_sale_rm_34p: 4500,
    buruburu_sale_rm_40p: 7000,
    buruburu_sale_rm_46p: 15000,
    buruburu_sale_cm_04p: 580,
    buruburu_sale_cm_10p: 1000,
    buruburu_sale_cm_16p: 1450,
    buruburu_sale_cm_22p: 2200,
    buruburu_sale_cm_28p: 2900,
    buruburu_sale_cm_34p: 3600,
    buruburu_sale_cm_40p: 4300,
    buruburu_sale_cm_46p: 5780,
    buruburu_sale_cm_52p: 7200,
    buruburu_sale_cm_58p: 14400,

    // Battle Pass - JYP
    buruburu_buru_pass: 1400,

    // Flash sale - JPY
    buruburu_flashsale_continue: 300,

    // Conversion sale - JPY
    buruburu_conversionsale_foryou: 100,

    // Piggy Bank - JPY
    buruburu_piggy_bank_200: 200,
    buruburu_piggy_bank_500: 500,
  };

/** @deprecated Stripe payments are deprecated and no longer used. */
export const stripeLivePriceIds: Record<ProductId, string> = {
  buruburu_gems_100: 'price_1MgPzcCva6KSREGvZvVOzScF',
  buruburu_gems_350: 'price_1MgQ00Cva6KSREGvRVh3TGGO',
  buruburu_gems_1000: 'price_1MgQ0MCva6KSREGvHypQYHLp',
  buruburu_gems_3200: 'price_1MgQ0gCva6KSREGvu4cMBfqs',
  buruburu_gems_6000: 'price_1MgQ1JCva6KSREGvy6FanvP1',
  buruburu_gems_12000: 'price_1MgQ1mCva6KSREGvaRJy66G1',
  buruburu_gems_18000: 'price_1NfEulCva6KSREGvSNj4z2Tw',

  // Shop Bundles Gems - JPY
  buruburu_gems_200: 'price_1NdqPXCva6KSREGv8evP2Zpp',
  buruburu_gems_1000_1200: 'price_1NdqPxCva6KSREGvTxJ1u05W',
  buruburu_gems_2000: 'price_1NdqQhCva6KSREGvYAUuM5Qn',
  buruburu_gems_5500: 'price_1NdqQqCva6KSREGvTJw320mf',
  buruburu_gems_10000: 'price_1NdqQyCva6KSREGvg73hShpA',
  buruburu_gems_20000: 'price_1NdqR7Cva6KSREGvkWPuGj2U',

  // Shop Bundles - JPY
  buruburu_pet_starter_pack: 'price_1PucvTCva6KSREGvb91ZDhZj',
  buruburu_pet_starter_pack_2: 'price_1Q825NCva6KSREGvwJAEKn1I',
  buruburu_pet_starter_pack_3: 'price_1QQAykCva6KSREGvKMrRK0jD',
  buruburu_starter_pack: 'price_1NdqRECva6KSREGvXcbjmqlL',
  buruburu_mini_pack: 'price_1NdqRMCva6KSREGvWlxIrZwx',
  buruburu_small_pack: 'price_1NdqRRCva6KSREGvs13evKvH',
  buruburu_medium_pack: 'price_1NdqRXCva6KSREGvThadNbBl',
  buruburu_large_pack: 'price_1NdqRcCva6KSREGvkd0qgqmq',
  buruburu_grande_pack: 'price_1NdqRiCva6KSREGv5wseHl1y',
  buruburu_jumbo_pack: 'price_1NdqRoCva6KSREGvpR9GdxTJ',

  // Bundle Sale - JPY
  buruburu_booster_sale: 'price_1NdsADCva6KSREGvIc4DIXue',
  buruburu_sale_rm_04p_2: 'price_1ODM68Cva6KSREGvtz7vvqdX',
  buruburu_sale_rm_10p: 'price_1ODM6dCva6KSREGvNX3IrSCW',
  buruburu_sale_rm_16p: 'price_1ODM78Cva6KSREGvgJzjrTHP',
  buruburu_sale_rm_22p: 'price_1ODM7aCva6KSREGvMbHDRNg0',
  buruburu_sale_rm_28p: 'price_1ODM88Cva6KSREGvc51HDlzt',
  buruburu_sale_rm_34p: 'price_1ODM8bCva6KSREGvOcKJE6Wf',
  buruburu_sale_rm_40p: 'price_1ODM95Cva6KSREGvmSckURt1',
  buruburu_sale_rm_46p: 'price_1ODM9bCva6KSREGveQTUmeGa',
  buruburu_sale_cm_04p: 'price_1ODMA9Cva6KSREGvkbGRVqTU',
  buruburu_sale_cm_10p: 'price_1ODMAdCva6KSREGvew9gC0Qc',
  buruburu_sale_cm_16p: 'price_1ODMB5Cva6KSREGvFdUv04Mf',
  buruburu_sale_cm_22p: 'price_1ODMBkCva6KSREGvsMSbPEAy',
  buruburu_sale_cm_28p: 'price_1ODMCGCva6KSREGvOd0tCXal',
  buruburu_sale_cm_34p: 'price_1ODMCpCva6KSREGvQg0s3sWq',
  buruburu_sale_cm_40p: 'price_1ODME5Cva6KSREGv1dTemWf7',
  buruburu_sale_cm_46p: 'price_1ODMEiCva6KSREGvhz7Zas7p',
  buruburu_sale_cm_52p: 'price_1ODMFDCva6KSREGvvt1Djoyx',
  buruburu_sale_cm_58p: 'price_1ODMFqCva6KSREGvODuLWs6K',

  // Battle Pass - JPY
  buruburu_buru_pass: 'price_1NlF2vCva6KSREGvXv0MbUfP',

  // Flash sale - JPY
  buruburu_flashsale_continue: 'price_1OfMxaCva6KSREGvSJbM4EhT',

  // Conversion sale - JPY
  buruburu_conversionsale_foryou: 'price_1Oh83pCva6KSREGvuPqUIyhV',

  // Piggy Bank
  buruburu_piggy_bank_200: 'price_live_TBD_piggy_bank_200',
  buruburu_piggy_bank_500: 'price_live_TBD_piggy_bank_500',
};

/** @deprecated Stripe payments are deprecated and no longer used. */
export const stripeTestPriceIds: Record<ProductId, string> = {
  buruburu_gems_100: 'price_1MgSNyCva6KSREGvmHWTWXp8',
  buruburu_gems_350: 'price_1MgSOICva6KSREGvt4t73opw',
  buruburu_gems_1000: 'price_1MgSObCva6KSREGvTwS2Bc9w',
  buruburu_gems_3200: 'price_1MgSOwCva6KSREGvgiDNEOt7',
  buruburu_gems_6000: 'price_1MgSPLCva6KSREGvHLUSzRAn',
  buruburu_gems_12000: 'price_1MgSPxCva6KSREGvbk52rDUy',
  buruburu_gems_18000: 'price_1MgSQCCva6KSREGv7ZQFJlTl',

  // Shop Bundles Gems - JPY
  buruburu_gems_200: 'price_1NcRnNCva6KSREGvI7zED1av',
  buruburu_gems_1000_1200: 'price_1NcRqnCva6KSREGvp4EVn1Wc',
  buruburu_gems_2000: 'price_1NcRsMCva6KSREGvl488eUEq',
  buruburu_gems_5500: 'price_1NcRtgCva6KSREGvJUOXl3XV',
  buruburu_gems_10000: 'price_1NcRuXCva6KSREGvnBCkZ0TV',
  buruburu_gems_20000: 'price_1NcRwGCva6KSREGvTkoMAeIw',

  // Shop Bundles - JPY
  buruburu_pet_starter_pack: 'price_1PucyOCva6KSREGvguwDAkTm',
  buruburu_pet_starter_pack_2: 'price_1Q80B1Cva6KSREGvifn9jt8d',
  buruburu_pet_starter_pack_3: 'price_1QQAwwCva6KSREGvVFeugRT7',
  buruburu_starter_pack: 'price_1NcRxgCva6KSREGvQ086bK94',
  buruburu_mini_pack: 'price_1NcRymCva6KSREGvALEQb0c6',
  buruburu_small_pack: 'price_1NcRzVCva6KSREGvCUXPRaQD',
  buruburu_medium_pack: 'price_1NcS0TCva6KSREGvviOLyj2p',
  buruburu_large_pack: 'price_1NcS1gCva6KSREGvzm5ytbaV',
  buruburu_grande_pack: 'price_1NcS2RCva6KSREGv7Gb57tFj',
  buruburu_jumbo_pack: 'price_1NcS30Cva6KSREGvPP5pr35g',

  // Bundle Sale - JPY
  buruburu_booster_sale: 'price_1Nds9uCva6KSREGvhTO2GU8P',
  buruburu_sale_rm_04p_2: 'price_1ODLqbCva6KSREGvVp5q3IXO',
  buruburu_sale_rm_10p: 'price_1ODLsyCva6KSREGvH7o0Mj8y',
  buruburu_sale_rm_16p: 'price_1ODLttCva6KSREGv7yERVXNE',
  buruburu_sale_rm_22p: 'price_1ODLuaCva6KSREGvRpM61vx3',
  buruburu_sale_rm_28p: 'price_1ODLvACva6KSREGv0r0pFVr0',
  buruburu_sale_rm_34p: 'price_1ODLvhCva6KSREGvFrbZfgLe',
  buruburu_sale_rm_40p: 'price_1ODLwCCva6KSREGvzZewhcZb',
  buruburu_sale_rm_46p: 'price_1ODLwuCva6KSREGvt1zaBNlK',
  buruburu_sale_cm_04p: 'price_1ODLxQCva6KSREGvFIb2rZqn',
  buruburu_sale_cm_10p: 'price_1ODLxuCva6KSREGvJKogSIWx',
  buruburu_sale_cm_16p: 'price_1ODLyRCva6KSREGvw8PN4Sy4',
  buruburu_sale_cm_22p: 'price_1ODLyvCva6KSREGvRWdupo1y',
  buruburu_sale_cm_28p: 'price_1ODLzRCva6KSREGvsgxsoZ7v',
  buruburu_sale_cm_34p: 'price_1ODLzxCva6KSREGvqj6ICgFD',
  buruburu_sale_cm_40p: 'price_1ODM0fCva6KSREGvLA965WTK',
  buruburu_sale_cm_46p: 'price_1ODM1ECva6KSREGvHhsjjKTo',
  buruburu_sale_cm_52p: 'price_1ODM2CCva6KSREGvr3DLA8hC',
  buruburu_sale_cm_58p: 'price_1ODM2oCva6KSREGvnquS5mgb',

  // Battle Pass - JPY
  buruburu_buru_pass: 'price_1NlF2ZCva6KSREGvglNHaHp4',

  // Flash sale - JPY
  buruburu_flashsale_continue: 'price_1OgQ0vCva6KSREGvwq84ObIb',

  // Conversion sale - JPY
  buruburu_conversionsale_foryou: 'price_1Oh84eCva6KSREGvcFvAoeIC',

  // Piggy Bank
  buruburu_piggy_bank_200: 'price_test_TBD_piggy_bank_200',
  buruburu_piggy_bank_500: 'price_test_TBD_piggy_bank_500',
};

/** @deprecated Stripe payments are deprecated and no longer used. */
export const STRIPE_PUBLISHABLE_KEY = process.env.IS_DEVELOPMENT
  ? 'pk_test_51Me7OaCva6KSREGvec9VquFbRYH2XAUcc9uXjccyIHttm3BWvEbtAsmMQkLCeikOoMpZcbuGFLGQRE8SO4X75KjX007dJqH3IB'
  : 'pk_live_51Me7OaCva6KSREGveaExQgl8agNNMC9tEt0wibepafWeHBe5WowzjRX6RRYwmOiCZh1sEwg7JxZt30k76T8qljB200Oudm4v3q';

export enum AtoneServiceType {
  ATONE = '01',
  ATONE_LITE = '04',
}

/**
 * The lifetime of a pending payment before it is cleared.
 */
export const PENDING_PAYMENT_TIMEOUT = duration({ hours: 24 });

/**
 * The interval at which pending payments are checked for cleanup.
 * KOMOJU's documentation doesn't specify a recommended duration for merchants to track pending payments.
 * However, it's important to note that pending payments have expiration periods that vary depending on the payment method and merchant configurations.
 * For instance, Konbini payments typically have a default pending period of 3 days, adjustable between 1 to 59 days.
 * For credit cards this period is 2 days, and unknown for other providers
 * Once a payment expires, it transitions to an "expired" status, indicating that the customer didn't complete the transaction within the allotted time.
 * Therefore, merchants should monitor pending payments and send reminders to customers before the payment expires to ensure completion.
 */
export const PENDING_PAYMENT_CLEANUP = duration({ days: 3 });

/**
 * Products that are from deactivated features and should not be tested
 */
export const DEACTIVATED_PRODUCTS: readonly string[] = [
  'buruburu_buru_pass',
  'buruburu_flashsale_continue',
  'buruburu_conversionsale_foryou',
  'buruburu_engagementsale_ticket',
  'buruburu_piggy_bank_200',
  'buruburu_piggy_bank_500',
];
